import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import HouseholdPage from "@/pages/HouseholdPage";
import DashboardPage from "@/pages/DashboardPage";
import ExpensesPage from "@/pages/ExpensesPage";
import HistoryPage from "@/pages/HistoryPage";
import RevenuPage from "@/pages/RevenuPage";
import StatisticsPage from "@/pages/StatisticsPage";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#42a5f5", light: "#90caf9", dark: "#1565c0" },
    secondary: { main: "#f59e0b" },
    background: { default: "#121212", paper: "#1e1e1e" },
    divider: "rgba(255, 255, 255, 0.08)",
  },
  components: {
    MuiAppBar: { styleOverrides: { root: { backgroundColor: "#1e1e1e", backgroundImage: "none", borderBottom: "1px solid rgba(255, 255, 255, 0.08)" } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiTab: { styleOverrides: { root: { textTransform: "none", fontWeight: 500, minHeight: 48 } } },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/household" element={<HouseholdPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Layout><ExpensesPage /></Layout></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><Layout><HistoryPage /></Layout></ProtectedRoute>} />
            <Route path="/revenues" element={<ProtectedRoute><Layout><RevenuPage /></Layout></ProtectedRoute>} />
            <Route path="/statistics" element={<ProtectedRoute><Layout><StatisticsPage /></Layout></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
